
export const PHONE_OS_TYPE = {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
    WINDOWS: 'WINDOWS',
    MAC: 'MAC',
    OTHERS: 'OTHERS'
  }

export const DEEPLINK_BASE_URL = "https://cdc.club100.hk/";